import { render, staticRenderFns } from "./BoardPreview.vue?vue&type=template&id=22435fa1&"
import script from "./BoardPreview.vue?vue&type=script&lang=ts&"
export * from "./BoardPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BoardPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports